import React from 'react';

export const ScribeMedicationIcon = () => {
  return (
    <svg
      width="20"
      height="21"
      viewBox="0 0 20 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M18.4483 7.38213H13.1179V2.05172C13.1179 1.9717 13.0861 1.89496 13.0295 1.83838C12.9729 1.78179 12.8962 1.75 12.8161 1.75H7.18386C7.10384 1.75 7.0271 1.78179 6.97051 1.83838C6.91393 1.89496 6.88214 1.9717 6.88213 2.05172V7.38213H1.55172C1.4717 7.38214 1.39496 7.41393 1.33838 7.47051C1.28179 7.5271 1.25 7.60384 1.25 7.68386V13.3161C1.25 13.3962 1.28179 13.4729 1.33838 13.5295C1.39496 13.5861 1.4717 13.6179 1.55172 13.6179H6.88213V18.9483C6.88214 19.0283 6.91393 19.105 6.97051 19.1616C7.0271 19.2182 7.10384 19.25 7.18386 19.25H12.8161C12.8962 19.25 12.9729 19.2182 13.0295 19.1616C13.0861 19.105 13.1179 19.0283 13.1179 18.9483V13.6179H18.4483C18.5283 13.6179 18.605 13.5861 18.6616 13.5295C18.7182 13.4729 18.75 13.3962 18.75 13.3161V7.68386C18.75 7.60384 18.7182 7.5271 18.6616 7.47051C18.605 7.41393 18.5283 7.38214 18.4483 7.38213Z"
        fill="#98A2B3"
      />
    </svg>
  );
};
export const ScribeDiagnosisIcon = () => {
  return (
    <svg
      width="21"
      height="21"
      viewBox="0 0 21 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.79878 5.90883C5.0732 5.4712 5.78526 5.4712 6.05969 5.90883L7.00911 7.42933L7.32804 7.94112L7.63954 7.45161C7.65439 7.41453 7.68404 7.37741 7.7137 7.34033C7.86205 7.16233 8.08455 7.0659 8.31448 7.08075H12.6239C12.9873 5.72341 12.6387 4.22513 11.5929 3.16449C10.8512 2.42278 9.86468 2.01485 8.81146 2.01485C8.81146 2.01485 8.80404 2.01485 8.79661 2.01485C7.91397 2.01485 7.07584 2.30413 6.38605 2.83814C5.69626 2.2967 4.8507 2 3.96064 2C2.89999 2 1.8987 2.42278 1.14957 3.18677C0.118576 4.23998 -0.222582 5.73826 0.140849 7.08075H4.06449L4.79878 5.90883Z"
        fill="#98A2B3"
      />
      <path
        d="M17.4445 4.50696C15.6198 4.50696 14.1364 5.99781 14.1364 7.82243C14.1364 9.39486 15.2341 10.7151 16.7028 11.0489C16.7027 11.0489 16.7028 11.0489 16.7028 11.0489L16.7029 12.9033C16.7029 15.4472 14.6328 17.5166 12.089 17.5166H11.7333C9.35536 17.5166 7.39293 15.708 7.14697 13.3941C7.21031 13.349 7.2716 13.3003 7.32751 13.2443L11.6072 8.87565C11.7036 8.7718 11.8 8.66799 11.889 8.56414H8.69224L7.95795 9.73602C7.82445 9.95114 7.58709 10.0846 7.32751 10.0846C7.07531 10.0846 6.83053 9.95114 6.69703 9.73602L5.74766 8.21552L5.42873 7.70373L5.1098 8.21552C4.98368 8.41579 4.78345 8.53445 4.5609 8.55672C4.53124 8.56414 4.50159 8.56414 4.47189 8.56414H0.867188C0.956189 8.67537 1.05262 8.77922 1.14904 8.87565L5.42873 13.2443C5.49994 13.3156 5.57957 13.3759 5.66332 13.4296C5.93151 16.5453 8.54936 19 11.7333 19H12.089C15.4513 19 18.1864 16.2649 18.1864 12.9033V11.0488C19.6623 10.7149 20.7599 9.39481 20.7599 7.82243C20.7599 5.99781 19.2765 4.50696 17.4445 4.50696ZM17.4593 8.56414C17.0513 8.56414 16.7176 8.23036 16.7176 7.82243C16.7176 7.4145 17.0439 7.08072 17.4518 7.08072H17.4593C17.8746 7.08072 18.201 7.4145 18.201 7.82243C18.201 8.23036 17.8746 8.56414 17.4593 8.56414Z"
        fill="#98A2B3"
      />
    </svg>
  );
};
export const ScribeAllergyIcon = () => {
  return (
    <svg
      width="20"
      height="21"
      viewBox="0 0 20 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_161_57350)">
        <path
          d="M13.4434 14.7723C12.5566 15.5297 11.3223 15.6645 10.5859 15.6684V17.5703C10.5859 17.8937 10.3234 18.1562 10 18.1562C9.67656 18.1562 9.41406 17.8937 9.41406 17.5703V15.6684C8.63086 15.6641 7.28359 15.5125 6.39141 14.6199C5.09648 13.325 5.36094 11.0703 5.37266 10.975C5.40586 10.709 5.61563 10.4992 5.88164 10.466C5.89375 10.4645 5.9418 10.459 6.01797 10.4527C5.15156 9.14609 5.36211 7.35117 5.37266 7.26641C5.39102 7.11953 5.46289 6.98984 5.56875 6.89766L2.52656 3.85547C0.892969 5.6875 0 8.02539 0 10.5C0 16.0271 4.47254 20.5 10 20.5C12.4746 20.5 14.8125 19.607 16.6445 17.9734L13.4434 14.7723ZM10 0.5C7.52539 0.5 5.1875 1.39297 3.35547 3.02656L7.08672 6.75781C7.32578 6.78164 7.58555 6.82148 7.85039 6.88672C7.80742 6.68633 7.7832 6.47852 7.7832 6.26484C7.7832 4.43359 9.56445 3.02617 9.64023 2.96719C9.85195 2.80273 10.148 2.80273 10.3598 2.96719C10.4355 3.02617 12.2168 4.43359 12.2168 6.26484C12.2168 6.47852 12.1926 6.68633 12.1496 6.88672C13.143 6.64258 14.0586 6.75 14.1184 6.75742C14.3844 6.79063 14.5941 7 14.6273 7.26641C14.6379 7.35117 14.8484 9.14609 13.982 10.4531C14.0582 10.459 14.1062 10.4645 14.1184 10.466C14.3844 10.4992 14.5941 10.709 14.6273 10.975C14.6371 11.0531 14.816 12.5793 14.1695 13.8406L17.4734 17.1445C19.107 15.3125 20 12.9746 20 10.5C20 4.97293 15.5275 0.5 10 0.5Z"
          fill="#98A2B3"
        />
        <path
          d="M13.4859 11.6082C13.4623 13.5715 12.5817 14.4834 10.5977 14.4965C10.6016 13.9035 10.7066 12.9098 11.3027 12.3133C11.8992 11.7172 12.8934 11.6121 13.4859 11.6082Z"
          fill="#98A2B3"
        />
        <path
          d="M9.40391 14.4965C8.81094 14.4926 7.81719 14.3879 7.2207 13.7914C6.62422 13.1949 6.51953 12.2012 6.51562 11.6082C7.10859 11.6125 8.10234 11.7172 8.69883 12.3133C9.29531 12.9098 9.4 13.9039 9.40391 14.4965Z"
          fill="#98A2B3"
        />
        <path
          d="M9.40391 10.7863C8.80977 10.7808 7.81289 10.675 7.2207 10.0828C6.62422 9.48632 6.51953 8.49218 6.51562 7.8996C8.57465 7.92128 9.39117 8.88639 9.40391 10.7863Z"
          fill="#98A2B3"
        />
        <path
          d="M10.5977 10.7863C11.1918 10.7808 12.1887 10.675 12.7809 10.0828C13.3773 9.48632 13.482 8.49218 13.4859 7.8996C11.4269 7.92128 10.6104 8.88639 10.5977 10.7863Z"
          fill="#98A2B3"
        />
        <path
          d="M11.0449 6.26484C11.0449 7.02266 10.5345 7.76621 10 8.30742C9.46504 7.76234 8.95508 7.02508 8.95508 6.26484C8.95508 5.42148 9.58359 4.64453 10 4.22266C10.4164 4.64492 11.0449 5.42188 11.0449 6.26484Z"
          fill="#98A2B3"
        />
      </g>
      <defs>
        <clipPath id="clip0_161_57350">
          <rect
            width="20"
            height="20"
            fill="white"
            transform="translate(0 0.5)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};
export const ScribeEditIcon = () => {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16 21.3333H22M10 21.3333H11.1164C11.4425 21.3333 11.6055 21.3333 11.759 21.2964C11.895 21.2638 12.0251 21.2099 12.1444 21.1368C12.279 21.0543 12.3943 20.939 12.6249 20.7084L21 12.3333C21.5523 11.781 21.5523 10.8856 21 10.3333C20.4477 9.781 19.5523 9.781 19 10.3333L10.6248 18.7084C10.3942 18.939 10.2789 19.0543 10.1965 19.1889C10.1234 19.3082 10.0695 19.4383 10.0368 19.5743C10 19.7278 10 19.8908 10 20.2169V21.3333Z"
        stroke="#475467"
        strokeWidth="1.33333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const ScribeDeleteIcon = () => {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M18.6667 12V11.4667C18.6667 10.72 18.6667 10.3466 18.5213 10.0614C18.3935 9.8105 18.1895 9.60653 17.9387 9.4787C17.6534 9.33337 17.2801 9.33337 16.5333 9.33337H15.4667C14.7199 9.33337 14.3466 9.33337 14.0613 9.4787C13.8105 9.60653 13.6065 9.8105 13.4787 10.0614C13.3333 10.3466 13.3333 10.72 13.3333 11.4667V12M14.6667 15.6667V19M17.3333 15.6667V19M10 12H22M20.6667 12V19.4667C20.6667 20.5868 20.6667 21.1469 20.4487 21.5747C20.2569 21.951 19.951 22.257 19.5746 22.4487C19.1468 22.6667 18.5868 22.6667 17.4667 22.6667H14.5333C13.4132 22.6667 12.8532 22.6667 12.4254 22.4487C12.049 22.257 11.7431 21.951 11.5513 21.5747C11.3333 21.1469 11.3333 20.5868 11.3333 19.4667V12"
        stroke="#475467"
        strokeWidth="1.33333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const ScribeModalDeleteIcon = () => {
  return (
    <svg
      width="56"
      height="56"
      viewBox="0 0 56 56"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect x="4" y="4" width="48" height="48" rx="24" fill="#FEE4E2" />
      <rect
        x="4"
        y="4"
        width="48"
        height="48"
        rx="24"
        stroke="#FEF3F2"
        strokeWidth="8"
      />
      <path
        d="M32 22V21.2C32 20.0799 32 19.5198 31.782 19.092C31.5903 18.7157 31.2843 18.4097 30.908 18.218C30.4802 18 29.9201 18 28.8 18H27.2C26.0799 18 25.5198 18 25.092 18.218C24.7157 18.4097 24.4097 18.7157 24.218 19.092C24 19.5198 24 20.0799 24 21.2V22M26 27.5V32.5M30 27.5V32.5M19 22H37M35 22V33.2C35 34.8802 35 35.7202 34.673 36.362C34.3854 36.9265 33.9265 37.3854 33.362 37.673C32.7202 38 31.8802 38 30.2 38H25.8C24.1198 38 23.2798 38 22.638 37.673C22.0735 37.3854 21.6146 36.9265 21.327 36.362C21 35.7202 21 34.8802 21 33.2V22"
        stroke="#F93C3C"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const ScribePlusCircleIcon = () => {
  return (
    <svg
      width="16"
      height="17"
      viewBox="0 0 16 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.99968 5.8335V11.1668M5.33301 8.50016H10.6663M14.6663 8.50016C14.6663 12.1821 11.6816 15.1668 7.99968 15.1668C4.31778 15.1668 1.33301 12.1821 1.33301 8.50016C1.33301 4.81826 4.31778 1.8335 7.99968 1.8335C11.6816 1.8335 14.6663 4.81826 14.6663 8.50016Z"
        stroke="#1974C7"
        strokeWidth="1.33333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const ScribeEditCircleIcon = () => {
  return (
    <svg
      width="16"
      height="17"
      viewBox="0 0 16 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.99998 13.8334H14M2 13.8334H3.11636C3.44248 13.8334 3.60554 13.8334 3.75899 13.7966C3.89504 13.7639 4.0251 13.71 4.1444 13.6369C4.27895 13.5545 4.39425 13.4392 4.62486 13.2086L13 4.8334C13.5523 4.28112 13.5523 3.38569 13 2.8334C12.4477 2.28112 11.5523 2.28112 11 2.8334L2.62484 11.2086C2.39424 11.4392 2.27894 11.5545 2.19648 11.689C2.12338 11.8083 2.0695 11.9384 2.03684 12.0744C2 12.2279 2 12.3909 2 12.7171V13.8334Z"
        stroke="#475467"
        strokeWidth="1.33333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const ScribeDeleteSmallIcon = () => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.6667 3.99992V3.46659C10.6667 2.71985 10.6667 2.34648 10.5213 2.06126C10.3935 1.81038 10.1895 1.60641 9.93865 1.47858C9.65344 1.33325 9.28007 1.33325 8.53333 1.33325H7.46667C6.71993 1.33325 6.34656 1.33325 6.06135 1.47858C5.81046 1.60641 5.60649 1.81038 5.47866 2.06126C5.33333 2.34648 5.33333 2.71985 5.33333 3.46659V3.99992M6.66667 7.66659V10.9999M9.33333 7.66659V10.9999M2 3.99992H14M12.6667 3.99992V11.4666C12.6667 12.5867 12.6667 13.1467 12.4487 13.5746C12.2569 13.9509 11.951 14.2569 11.5746 14.4486C11.1468 14.6666 10.5868 14.6666 9.46667 14.6666H6.53333C5.41323 14.6666 4.85318 14.6666 4.42535 14.4486C4.04903 14.2569 3.74307 13.9509 3.55132 13.5746C3.33333 13.1467 3.33333 12.5867 3.33333 11.4666V3.99992"
        stroke="#475467"
        strokeWidth="1.33333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
// export const ScribeModalDeleteIcon = () => {
//   return (
//     <svg
//       width="16"
//       height="16"
//       viewBox="0 0 16 16"
//       fill="none"
//       xmlns="http://www.w3.org/2000/svg"
//     >
//       <path
//         d="M10.6667 3.99992V3.46659C10.6667 2.71985 10.6667 2.34648 10.5213 2.06126C10.3935 1.81038 10.1895 1.60641 9.93865 1.47858C9.65344 1.33325 9.28007 1.33325 8.53333 1.33325H7.46667C6.71993 1.33325 6.34656 1.33325 6.06135 1.47858C5.81046 1.60641 5.60649 1.81038 5.47866 2.06126C5.33333 2.34648 5.33333 2.71985 5.33333 3.46659V3.99992M6.66667 7.66659V10.9999M9.33333 7.66659V10.9999M2 3.99992H14M12.6667 3.99992V11.4666C12.6667 12.5867 12.6667 13.1467 12.4487 13.5746C12.2569 13.9509 11.951 14.2569 11.5746 14.4486C11.1468 14.6666 10.5868 14.6666 9.46667 14.6666H6.53333C5.41323 14.6666 4.85318 14.6666 4.42535 14.4486C4.04903 14.2569 3.74307 13.9509 3.55132 13.5746C3.33333 13.1467 3.33333 12.5867 3.33333 11.4666V3.99992"
//         stroke="#475467"
//         strokeWidth="1.33333"
//         strokeLinecap="round"
//         strokeLinejoin="round"
//       />
//     </svg>
//   );
// };
